<template>
    <div class="contractBox">
        <div>
            <div class="contractTitle">
                <div style="width: 5px;height: 18px;background-color: #3e62f6"></div>
                <p>合同基本信息</p>
                <div class="enterpriseName">
                    <img src="../../../assets/img/coordinate.png" alt="">
                    <p>{{basicInformation.company_name}}</p>
                </div>
<!--                <div class="contractCopies">-->
<!--                    <span>剩余合同份数:</span>-->
<!--                    <p>{{basicInformation.contract_num}}份</p>-->
<!--                </div>-->

            </div>
            <div class="contractContent">
                <div class="contractName">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                        <el-form-item prop="doc_title" label="合同名称" style="display: flex">
                            <el-input v-model="ruleForm.doc_title" placeholder="请输入合同名称"></el-input>
                        </el-form-item>
                        <el-form-item  label="合同编号" style="display: flex">
                            <el-input v-model="ruleForm.contract_sn" placeholder="不填系统会自动生成"></el-input>
                        </el-form-item>
                        <el-form-item   label="签署截止时间" style="display: flex" :rules="[{ required: true, trigger: 'blur' },]">
                            <el-date-picker
                                    v-model="time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item  label="支付金额" style="display: flex" :rules="[{ required: true, trigger: 'blur' },]">
                            <el-input v-model="ruleForm.money" placeholder="请输入支付金额(仅支持整数)" :disabled="ruleForm.mode==2"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <!--        设置签署方-->
        <div style="margin-bottom: 50px">
            <div class="signatoryBox">
                <div style="width: 5px;height: 18px;background-color: #3e62f6"></div>
                <p>设置签署方</p>
            </div>
            <div style="margin: 30px 0px">
                <div class="participateBox" >
                    <div class="payer">选择支付方</div>
                    <div class="participate">参与主体</div>
                    <div class="signatory">签署方</div>
                    <div class="signed">参与方信息</div>
                    <!--                    <div class="operation">操作</div>-->
                </div>
                <div >
                    <div class="chooseBox" v-for="(item,index) in signers" :key="index">
                        <div class="payOptions">
                                <el-radio v-model="is_payer" :label="item.id">{{item.zt_name}}</el-radio>
                        </div>
                        <div class="choose" >
                            <p>{{item.zt_type_txt}}</p>
                        </div>
                        <div class="side">
                            <p>{{item.zt_name}}</p>
                        </div>
                        <div class="information">
                            <el-input  v-model="item.name"  placeholder="真实姓名" style="width: 50%" ></el-input>
                            <el-input  v-model="item.mobile" oninput ="value=value.replace(/[^0-9.]/g,'')" maxlength="11"  placeholder="请输入手机号" style="margin: 0px 5px;width: 80%"></el-input>
                            <el-input  v-model="item.com_name" placeholder="请输入企业完整名称" v-if="item.zt_type==1" ></el-input>
                        </div>
                        <!--                        <div class="operate">-->
                        <!--                            <el-button  class="View">校验信息</el-button>-->
                        <!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
        <!--        下一步-->
        <div class="nextStep">
            <el-button class="View" @click="browseBtn">预览合同</el-button>
            <el-button class="View" @click="dialogVisible=true">发起签署</el-button>
        </div>
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal = "false"
                width="30%">
            <span>请确认您填的信息是否正确</span>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="nextStepBtn" v-loading.fullscreen.lock="fullscreenLoading">确 认</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import { onlineSignPay, paymentModeDetails, previewContract, signatureInterface } from '../../../api/templateList';
    import { parseQuery } from '../../../utils/parsing';
    import bus from '../../../components/common/bus';
    export default {
        name: 'basicInformationpay',
        data(){
            return{
                ruleForm:{
                    doc_title:'',
                    contract_sn:'',
                    time:[],
                    mode:'',
                    money:'',
                },
                is_payer:'',
                time:'',
                dialogVisible: false,  //弹框
                fullscreenLoading:false, //loading
                name:'', //姓名
                compellation:'',
                customBizNum:'', //url参数
                phone:'', //手机号
                number:'',
                enterprise:'', //企业名称
                firm:'',
                options: [{
                    value: 'personal',
                    label: '个人'
                }, {
                    value: 'enterprise',
                    label: '企业'
                }],
                valuetype: '企业',
                value:'personal',
                basicInformation:'',
                signers:[],
                rules: {
                    doc_title: [
                        { required: true, message: '合同名称不能为空', trigger: 'blur' },
                    ],
                    // time:[
                    //     { required: true, message: '截止时间不能为空', trigger: 'blur' },
                    // ]
                }
            }
        },
        methods:{
            //下一步
            nextStepBtn(){
                if (this.is_payer==''){
                    this.$message.error('请选择支付方')
                }else {
                    this.signers.forEach(res=>{
                        if (res.id==this.is_payer){
                            res.is_payer=1
                        }else {
                            res.is_payer=0
                        }
                    })
                    this.fullscreenLoading=true
                    sessionStorage.removeItem('xinxi');
                    onlineSignPay(this.customBizNum,this.ruleForm.doc_title,this.ruleForm.contract_sn,this.time,this.ruleForm.money,this.signers).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg);
                            this.dialogVisible=false
                            this.fullscreenLoading=false
                            bus.$emit('close_current_tags')
                            this.$router.push({path:'/orderList'})
                        }else {
                            this.$message.error(res.msg);
                            this.fullscreenLoading=false
                        }
                    })
                }


            },
            //预览合同
            browseBtn(){
                previewContract(this.customBizNum).then(res=>{
                    if (res.code==200){
                        window.open(res.data.fileDownloadUrl, '_blank');
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            // getNowdate(){
            //     var date_now = new Date()//获取当前时间
            //     var year = date_now.getFullYear()//获取当前时间的年份
            //     var month = date_now.getMonth()//获取当前时间的月份
            //     var day = date_now.getDate()//获取当前时间的日
            //     var days = new Date(year,month,0)//将获取到的年月赋值给days
            //     days = days.getDate()//获取当前年月的日
            //     var year2 = year
            //     var month2 =  parseInt(month+2)//获取当前月份的1一个月以后的月份
            //     if(month2 > 12){
            //         year2 = parseInt(year2) + 1
            //         month2 = parseInt(month2) % 12
            //     }//考虑到12月要是获取一个月以后，就是一月，年份需要加一 ，一年没有13月，所以%12，取得来年1月
            //     var day2 = day
            //     var days2 = new Date(year2,month2,0)
            //     days2 = days2.getDate()
            //     if(day2>days2){
            //         day2 = days2
            //     }//获取了当前年份的日和1个月以后的日，为的就是判断如果前一个月是有31号，后一个月没有，就将一个月以后的日期取到，赋值给day2
            //     if(month2 < 10){
            //         month2 = '0' + month2
            //     }
            //     var time = year2 + '-' + month2 + '-' + day2
            //     return time
            // },
            GetDateStr(date) {
                var dd = new Date();
                dd.setDate(dd.getDate() + date);//获取AddDayCount天后的日期
                var y = dd.getFullYear();
                var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
                var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
                return y + "-" + m + "-" + d;
            }
        },
        created() {
            let { customBizNum} = parseQuery();
            customBizNum=customBizNum.split('#')[0]
            this.customBizNum=customBizNum
            paymentModeDetails(customBizNum).then(res=>{
                if (res.code==200){
                    this.basicInformation=res.data
                    this.ruleForm=res.data
                    this.signers=res.data.signers
                }
            })

            this.time=this.GetDateStr(89)
            // this.time=this.getNowdate()
        }
    };
</script>

<style scoped>
    .contractBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .contractTitle{
        display: flex;
        align-items: center;
    }
    .contractTitle>p{
        margin-left: 10px;
    }
    .contractContent{
        margin: 20px 0px;
        overflow: hidden;
        color: #333333;
    }
    .contractName{
        display: flex;
        margin: 10px 0px;
        align-items: center;
    }
    .contractCopies{
        display: flex;
        font-size: 14px;
        color: #999999;
    }
    .contractCopies>p{
        margin-left: 10px;
    }
    .enterpriseName{
        margin:0px 20px;
        padding: 0px 10px;
        border-radius: 10px;
        background-color: #ebf2ff;
        display: flex;
        align-items: center;
    }
    .enterpriseName>p{
        font-size: 14px;
        padding: 0px 10px;
        color: #333333;
    }
    .enterpriseName>img{
        width: 18px;
    }
    /*    设置签署方*/
    .signatoryBox{
        display: flex;
        align-items: center;
    }
    .signatoryBox>p{
        margin-left: 10px;
    }
    .participateBox{
        display: flex;
        align-items: center;
        height: 50px;
        background-color: #f3f3f9;
        color: #525961;
        padding: 0px 20px;
    }
    .participate{
        width: 15%;
    }
    .signatory{
        width: 15%;
    }
    .signed{
        width: 40%;
    }
    .payer{
        width: 10%;
    }
    .operation{
        width: 20%;
        text-align: center;
    }
    /deep/.el-select--small{
        width: 100px;
    }
    .chooseBox{
        display: flex;
        margin: 20px 0px;
        padding: 0px 20px;
    }
    .payOptions{
        width: 10%;
    }
    .choose{
        width: 15%;
        color: #525961;
    }
    .information{
        width: 40%;
        display: flex;
    }
    .operate{
        width: 20%;
        text-align: center;
    }
    .side{
        width: 15%;
        color: #525961;
    }
    .operate>button{
        background-color: #3d62f6;
        color: #fff;
    }
    .View{
        background-color: #3e62f6;
        color: #fff;
    }
    .nextStep{
        text-align: center;
    }
    /deep/.el-form-item{
        justify-content: flex-end;
    }
    .browse{
        margin: 0px 20px;
        font-size: 14px;
        color: #3e62f6;
        cursor: pointer;
    }
    /deep/.el-date-editor{
        width: 200px;
    }
</style>
